import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./header";
import Sidebar from "./sidebar";

function getTitleFromPath(pathname) {
  if (pathname === "/" || pathname === "/dashboard") return "Dashboard";
  if (pathname.startsWith("/users")) {
    if (pathname.endsWith("/new")) return "Add New User";
    if (pathname.endsWith("/edit")) return "Edit User";
    if (pathname.match(/^\/users\/[^/]+$/)) return "User Detail";
    return "User Management";
  }
  if (pathname.startsWith("/course-progress")) return "Course Progress";
  if (pathname.startsWith("/purchases")) return "Purchases";
  if (pathname.startsWith("/coupon-redemptions")) return "Applied Coupons";
  if (pathname.startsWith("/user-activity")) return "User Activity";
  if (pathname.startsWith("/course-sales")) {
    if (pathname.endsWith("/new")) return "Add Sale";
    if (pathname.endsWith("/edit")) return "Edit Sale";
    return "Course Sales";
  }
  if (pathname.startsWith("/coupons")) {
    if (pathname.endsWith("/new")) return "Add Coupon";
    if (pathname.endsWith("/edit")) return "Edit Coupon";
    return "Coupons";
  }
  if (pathname.startsWith("/coaching-hacks")) {
    if (pathname.endsWith("/new")) return "Add Coaching Hack";
    if (pathname.endsWith("/edit")) return "Edit Coaching Hack";
    return "Coaching Hacks";
  }
  if (pathname.startsWith("/daily-prompts")) {
    if (pathname.endsWith("/new")) return "Add Daily Prompt";
    if (pathname.endsWith("/edit")) return "Edit Daily Prompt";
    return "Daily Prompts";
  }
  if (pathname.startsWith("/reflections-screens")) {
    if (pathname.includes("/category-reflections") && pathname.endsWith("/edit")) return "Edit Category Reflection";
    if (pathname.includes("/category-reflections") && pathname.endsWith("/new")) return "Add Category Reflection";
    if (pathname.includes("/category-reflections")) return "Category Reflections";
    if (pathname.includes("/overall-reflections") && pathname.endsWith("/edit")) return "Edit Overall Reflection";
    if (pathname.includes("/overall-reflections") && pathname.endsWith("/new")) return "Add Overall Reflection";
    if (pathname.includes("/overall-reflections")) return "Overall Reflections";
    if (pathname.includes("/static-screens") && pathname.endsWith("/edit")) return "Edit Static Screen";
    if (pathname.includes("/static-screens") && pathname.endsWith("/new")) return "Add Static Screen";
    if (pathname.includes("/static-screens")) return "Static Screens";
    return "Reflections & Screens";
  }
  if (pathname.startsWith("/growth-snapshots")) {
    if (pathname.match(/\/questions\/[^/]+\/edit$/)) return "Edit Question";
    if (pathname.match(/\/questions\/new$/)) return "Add Question";
    if (pathname.match(/\/questions$/)) return "Questions";
    if (pathname.match(/\/steps\/[^/]+\/edit$/)) return "Edit Step";
    if (pathname.match(/\/steps\/new$/)) return "Add Step";
    if (pathname.match(/\/steps$/)) return "Steps";
    if (pathname.match(/\/sections\/[^/]+\/edit$/)) return "Edit Section";
    if (pathname.match(/\/sections\/new$/)) return "Add Section";
    if (pathname.match(/\/content$/)) return "Reflections & screens";
    if (pathname.match(/\/sections$/)) return "Sections";
    if (pathname.endsWith("/new")) return "Add Growth Snapshot";
    if (pathname.endsWith("/edit")) return "Edit Growth Snapshot";
    return "Family Growth Snapshots";
  }
  if (pathname.startsWith("/courses")) {
    if (pathname.endsWith("/new")) return "Add New Course";
    if (pathname.endsWith("/edit")) return "Edit Course";
    if (pathname.match(/^\/courses\/[^/]+\/weeks\/new$/)) return "Add Week";
    if (pathname.match(/^\/courses\/[^/]+\/weeks\/[^/]+\/edit$/)) return "Edit Week";
    if (pathname.match(/^\/courses\/[^/]+\/weeks\/[^/]+$/)) return "Week Content";
    if (pathname.match(/^\/courses\/[^/]+\/weeks$/)) return "Manage Weeks";
    return "Courses";
  }
  if (pathname.startsWith("/info-videos")) {
    if (pathname.endsWith("/new")) return "Add Info Video";
    if (pathname.endsWith("/edit")) return "Edit Info Video";
    return "Info Videos";
  }
  if (pathname.startsWith("/cms-content")) {
    if (pathname.endsWith("/new")) return "Add CMS Content";
    if (pathname.endsWith("/edit")) return "Edit CMS Content";
    return "CMS Content";
  }
  if (pathname.startsWith("/sales-content")) {
    if (pathname.endsWith("/new")) return "Add Sales Content";
    if (pathname.endsWith("/edit")) return "Edit Sales Content";
    return "Sales Content";
  }
  if (pathname.startsWith("/resource-hub")) {
    if (pathname.endsWith("/new")) return "Add Resource Hub Item";
    if (pathname.endsWith("/edit")) return "Edit Resource Hub Item";
    return "Resource Hub";
  }
  if (pathname.startsWith("/settings")) return "Settings";
  if (pathname.startsWith("/xero-settings")) return "Xero Settings";
  return "KLC Admin";
}

export default function Layout() {
  const { pathname } = useLocation();

  return (
    <>
      <Sidebar />
      <main className="main">
        <Header title={getTitleFromPath(pathname)} />
        <Outlet />
      </main>
    </>
  );
}

